import styled from"@emotion/styled";import{FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import Button from"@wp/src/components/common/button";export const RealEstateItemsContainer=styled(FlexLayout)`
  flex-direction: column;
  width: inherit;
`;export const RealEstateItemContainer=styled.div`
  width: 100%;
  border-radius: 0;
  border-bottom: 1px solid ${props=>props.theme.colors.neutral300};
  padding: 16px;
`;export const RealEstateItemRowContent=styled(FlexLayout)`
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
`;export const RealEstateDetailsContainer=styled(FlexLayout)`
  flex-direction: column;
  align-items: flex-start;
`;export const RealEstateActionsContainer=styled(FlexLayout)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
`;export const DeleteRealEstateButton=styled(Button)`
  border: none;
`;export const PropertyLabel=styled.div`
  display: flex;
  column-gap: 4px;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: ${props=>props.theme.colors.neutral800};
  text-align: left;
`;export const DetailedSectionActionsContainer=styled(FlexLayout)`
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 16px;

  ${mediaQuery({justifyContent:["space-between","flex-start"]})}

  > button {
    ${mediaQuery({width:["100%","auto"],minWidth:["144px"]})}
  }
`;